import localization from "../../../../config/localization";
import { SidebarAccordion } from "../SidebarAccordion";
import { SidebarSubItem } from "../SidebarSubItem";
import { SidebarDivider } from "../SidebarDivider";
import { SidebarItem } from "../SidebarItem";
import { useEffect, useState } from "react";
import homeService from "../../../../features/home/services/home.service";
interface AccountMenuProps {
  openAccordion: string | null;
  toggleAccordion: (id: string) => void;
  handleNavigate: (path: string) => void;
  isAuthenticated: boolean;
}

type CmsPage = {
  id: string;
  pagename: string;
  pageurl: string;
  active: boolean;
};

export function AccountMenu({
  openAccordion,
  toggleAccordion,
  handleNavigate,
  isAuthenticated,
}: AccountMenuProps) {
  const [cmsPages, setCmsPages] = useState<CmsPage[]>([]);

  useEffect(() => {
    const loadCms = async () => {
      const res = await homeService.fetchCmsUserList();
      const details = res?.data?.details ?? [];

      setCmsPages(details.filter((x: CmsPage) => x.active));
    };

    loadCms();
  }, []);

  const onCmsClick = (url: string) => {
    handleNavigate(`/${url}`);
  };

  const staticRulesSlugs = [
    "TermsAndConditions",
    "Exchange Rules",
    "Sportsbook Rules",
    "Glossary",
  ];

  const rules: CmsPage[] = [];
  const others: CmsPage[] = [];

  for (const p of cmsPages) {
    const pageName = (p.pagename || "").toLowerCase();

    if (staticRulesSlugs.includes(p.pagename)) {
      rules.push(p);
      continue;
    }

    if (pageName.includes("rule") || pageName.includes("rules")) {
      rules.push(p);
    } else {
      others.push(p);
    }
  }

  return (
    <>
      <div className="mx-4 border border-[#2E2E2E] bg-[#0F0F0F] rounded-xl overflow-hidden">

        {isAuthenticated && (
          <>
            <SidebarAccordion
              id="banking"
              label={localization.banking}
              imgSrc={"/icons/ic-sidebar-terms-and-conditions.svg"}
              isOpen={openAccordion === "banking"}
              onToggle={toggleAccordion}
            >
              <SidebarSubItem
                imgSrc={"/icons/ic-deposit.svg"}
                label={localization.deposit}
                onClick={() => handleNavigate("/deposit")}
              />
              <SidebarSubItem
                imgSrc={"/icons/ic-withdraw.svg"}
                label={localization.withdraw}
                onClick={() => handleNavigate("/withdrawal")}
              />
            </SidebarAccordion>
            <SidebarDivider />


            <SidebarAccordion
              id="transaction"
              label={localization.transaction}
              imgSrc={"/icons/ic-sidebar-transaction.svg"}
              isOpen={openAccordion === "transaction"}
              onToggle={toggleAccordion}
            >
              <SidebarSubItem
                imgSrc={"/icons/ic-wallet.svg"}
                label={localization.wallet}
                onClick={() => handleNavigate("/wallethistory")}
              />
              <SidebarSubItem
                imgSrc={"/icons/ic-transaction.svg"}
                label={localization.transactions}
                onClick={() => handleNavigate("/transactions")}
              />
            </SidebarAccordion>

            <SidebarDivider />

            <SidebarItem
              imgSrc={"/icons/ic-sidebar-bonus.svg"}
              label={localization.bonus}
              onClick={() => handleNavigate("/bonus")}
            />
          </>
        )}
      </div>

      {rules.length > 0 && (
        <div className="mx-4 mt-4 border border-[#2E2E2E] bg-[#0F0F0F] rounded-xl overflow-hidden">
          <SidebarAccordion
            id="rules"
            label={localization.rules}
            isOpen={openAccordion === "rules"}
            onToggle={toggleAccordion}
          >
            {rules.map((item) => (
              <SidebarSubItem
                key={`cms-rules-${item.id}`}
                imgSrc={getIconForPage(item.pagename)}
                label={localization.getString(item.pageurl.toLowerCase())}
                onClick={() => onCmsClick(item.pageurl)}
              />
            ))}
          </SidebarAccordion>
        </div>
      )}

      {others.length > 0 && (
        <div className="mx-4 mt-4 border border-[#2E2E2E] bg-[#0F0F0F] rounded-xl overflow-hidden">
          <SidebarAccordion
            id="others"
            label={localization.others}
            isOpen={openAccordion === "others"}
            onToggle={toggleAccordion}
          >
            {others.map((item) => (
              <SidebarSubItem
                key={`cms-others-${item.id}`}
                imgSrc={getIconForPage(item.pagename)}
                label={localization.getString(item.pageurl.toLowerCase())}
                onClick={() => onCmsClick(item.pageurl)}
              />
            ))}
          </SidebarAccordion>
        </div>
      )}
    </>
  );
}

const getIconForPage = (pageName: string) => {
  const iconMap = [
    {
      name: "TermsAndConditions",
      icon: "/icons/ic-sidebar-terms-and-conditions.svg",
    },
    { name: "Exchange Rules", icon: "/icons/ic-sidebar-exchange-rules.svg" },
    {
      name: "Sportsbook Rules",
      icon: "/icons/ic-sidebar-sports-book-rules.svg",
    },
    { name: "Glossary", icon: "/icons/ic-sidebar-glossary.svg" },
    { name: "About Us", icon: "/icons/ic-sidebar-about-us.svg" },
    { name: "Blog", icon: "/icons/ic-sidebar-blog.svg" },
    { name: "KycPolicy", icon: "/icons/ic-sidebar-kyc-policy.svg" },
    {
      name: "SelfExclusionPolicy",
      icon: "/icons/ic-sidebar-self-exclusion-policy.svg",
    },
    { name: "PrivacyPolicy", icon: "/icons/ic-sidebar-privacy-policy.svg" },
    { name: "Help", icon: "/icons/ic-sidebar-help.svg" },
    { name: "Affiliates", icon: "/icons/ic-sidebar-affiliate-rules.svg" },
    { name: "PaymentMethods", icon: "/icons/ic-sidebar-payment-methods.svg" },
    {
      name: "ResponsibleGaming",
      icon: "/icons/ic-sidebar-responsible-gaming.svg",
    },
  ];

  const mapping = iconMap.find(
    (m) => m.name.toLowerCase() === pageName.toLowerCase(),
  );

  return mapping ? mapping.icon : "/icons/ic-sidebar-terms-and-conditions.svg";
};
